// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  prefix:'dev_',
  firebaseConfig : {
    apiKey: "AIzaSyDrq4sHSaQBO-NxLj0OHqXjB4miKKIiI2c",
    authDomain: "afrimart-fb9f8.firebaseapp.com",
    projectId: "afrimart-fb9f8",
    storageBucket: "afrimart-fb9f8.appspot.com",
    messagingSenderId: "134224577769",
    appId: "1:134224577769:web:4b3a34ef629b1bb6195c78",
    measurementId: "G-0H57S256W8"
  },
  mapKey:  "AIzaSyBBEynhMRGDVyWfyOPZ6FBMWcJwxHM3zGI",//"AIzaSyBEW60pBY3MX5t_DmXBo3NjEX5geXrsBkk",
  vapidKey:"BCLBt6Zc-ILacU0BiPSultaZMkm-w9laMkdQOS0xfZiZ-J6EwmhOi9PKNBGtRszaNlq-GNiVQFnC8HDz8Jay26k",
  api:'https://ruecart-ca-vendor-dev-134224577769.us-central1.run.app/',
  storeLink:"https://app-dev.ruecart.com/store/",
  STRIPE_PK:'pk_test_51R9WR1CVfNGLn7duQrYBYD4axwYcacxNVAXemmjFWWIDXqFLNFG3HELHfWyaZmKVLgKoM2fcFSyxbmTao2f2ToRE00jxHhvxKe',

  collections:{
    VENDOR: 'vendor',  // Collection for vendor
    PRODUCTS: 'products',  // Collection for product
    SERVICES: 'services',  // Collection for services
    CLIENT:'client',      //Collection for client user
    VENDOR_ORDER:'vendor_order',     //Collection for vendor order
    VENDOR_SERVICE_ORDER:'vendor_service_order',
    VENDOR_USERS:'vendor_user',
    EVENTS:'events',
    TICKETS:'tickets',
  },
  endpoints:{
    MESSAGING: 'order/messaging',   //endpoint for messaging
    SERVICES_MESSAGING: 'service/messaging',   //endpoint for services messaging
    UPDATES: 'order/updates',        // endpoint for updates/vendor actions on orders
    SERVICES_UPDATES: 'service/updates', // endpoint for updates/vendor actions on services orders
    UPDATE_TOKEN: 'order/messaging/register-token',
    PRODUCT: 'product',
    PRODUCT_DELETE: 'product/delete',
    SERVICE: 'service',
    CHECK_EMAIL: 'vendor/check-email',
    // VENDOR: 'create_baines_vendor',//'vendor', Changed for BainesCredit Bank
    VENDOR: 'vendor',
    QUERY_BANK_CUSTOMER: 'create_baines_vendor/existing-bank-customer', //Query Baines Existing bank customer
    INITIATE_BVN: 'create_baines_vendor/initiate-bvn-validation',
    BVN_VALIDATION: 'create_baines_vendor/bvn-otp-validation',
    GLOBAL_AVAILABILITY:'service/availability',
    SEND_FEEDBACK:'feedback',
    CREATE_VENDOR_USER:'user/create-vendor-user',
    CHANGE_VENDOR_USER_STATUS:'user/update-status', //To activate or deactivate user
    CHANGE_VENDOR_ADMIN_STATUS:'user/update-admin-status', //To activate or deactivate user,
    HELP:'help',
    TRANSLATE:'translate',
    EVENT:'event',
    EVENT_DELETE:'event/delete',
    TICKETS:'ticket',
    CHECKOUT_SESSION:'create-checkout-session',
    REPORTS:'report',
    


   
  }

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
